import type { Route } from '~/core/router'

import { appearanceFeature } from '~/features/appearance'
import * as root from '~/routes/dynamic-module/root'
import { InfoPopup } from '~/widgets/Popups'

export const route: Route = {
  filter: {
    source: appearanceFeature.$modules,
    fn: (modules, { identifier }) => {
      if (modules) {
        for (const mod of modules) {
          if (mod.identifier === identifier && mod.type === 'dynamic') {
            return
          }
        }
        return false // 404 in case of unknown module identifier
      }
    },
  },

  children: [
    {
      path: '',
      component: [root.Title, root.DynamicPage, InfoPopup],
      init: root.model.init,
      left: root.model.left,
    },
  ],
}
